import {nuskin, util, RunConfigService, ConfigService, events, storage, Base64, BrowserDetection} from '@nuskin/ns-util';
import UserService from './userService.js';
import BuyerCookieService from './buyerCookieService.js';
import User from './user.js';
import Buyer from './buyer.js';
import VGDistInfoService from './vgDistInfoService.js'
import AuthenticationService from './authenticationService.js'

let ORDER_STORAGE_KEY = 'orders';
let ORDER_PREFS_STORAGE_KEY = 'orderPreferences';

//don't override if present
if (!nuskin.account) {

    nuskin.account = {
        GLOBAL_AUTH_RETURN_OBJECT: "businessEntity",
        EID_LOGIN_PATH: "/apps/global/services/eidlogin.html",
        ERROR_COOKIE_NAME: "nuskin-staticauth-error"
    };

    /**
     * AccountManager definition
     * AccountManager
     *
     * @namespace AccountManager
     */
    function AccountManager() {
        let thisAM = this;
        let initialized = false;
        let keys = storage.keys;
        // var nsConfig = ConfigService.getMarketConfig();  Leave commented out.  Needs to be local to the function


        // For the dashboard url (office link)
        this.dashboardUrlCookieName = keys.DASHBOARD_URL;
        this.segmentMapping = "";
        this.defaultDashboardUrl = "";
        this.dashboardUrl = ""; // todo move to configuration or Site

        this.currentData = null;
        this.afterLogoutRedirect = null; // todo should be moved to configuration or a Site service

        // todo replace all calls to this with the UserService
        this.isLoggedIn = function() {
            return UserService.getUser();
        };

        // todo replace all calls to this with the UserService
        this.isDistributor = function() {
            let user = UserService.getUser();
            return user !== null? user.isDistributor() : false;
        };

        // todo replace all calls to this with the UserService
        this.isCustomer = function() {
            let user = UserService.getUser();
            return user !== null? user.isCustomer() : false;
        };

        // todo replace all calls to this with the UserService
        this.isPreferredCustomer = function() {
            let user = UserService.getUser();
            return user !== null? user.isPreferredCustomer() : false;
        };

        // todo doesnt belong here, we should ask configuration or a SiteService this question - BUT we can most likely just remove this function
        this.isEmeaSignup = function() {
            let emeaSignupFlag = $.cookie("account-detail") != null;
            if (emeaSignupFlag && document.URL.indexOf("zh_TW") === -1) {
                return true;
            }
            return false;
        };

        // todo same as above
        this.setupEMEASignup = function() {
            let preferences = nuskin.site.PreferencesCookieService.getPreferences();
            preferences.setRibbonOpen(false);
            nuskin.site.PreferencesCookieService.setPreferences(preferences);
            let user = UserService.getUser();
            if (!user || user.id !== "-") {
                this.anonyousSignin();
            }
            events.publish(events.authentication.EMEASIGNUP_FLAG);
            if(!initialized) {
                initialized = true;
                events.setValue(events.account.INIT_COMPLETE);
            }
        };

        // TODO: this was moved from nuskin.util to prevent circular dependency
        // May not work.
        this.setOmniturePinLevel = function() {
            // Do a try catch to avoid any problems for the enclosed code...
            try {
                if (this.isLoggedIn()) {
                    let pinLevel = this.currentData.highestRank;
                    if (typeof pinLevel !== 'undefined') {
                        s.eVar11=pinLevel;
                    }
                }
            } catch (e) {}
        };

        this.guestCheckoutLoginHandler = function (result) {
            result = JSON.stringify(result);
            let resultObject = JSON.parse(result);
            // Set login time.
            resultObject.loginTime = new Date().getTime();

            thisAM.currentData = resultObject;
            //set the cookie to initialize the "session"
            UserService.setUser(resultObject);
            UserService.setLoggedIn(true);
            saveUserBuyerCookieForEcom3(thisAM.currentData);
        };

        //this should only be called during customer (or other) signup
        //where they have just accepted the PnP, so no need to check here
        let silentAuthReturnHandler = function(result) {
            console.log("silentAuthReturnHandler:: ");
            result = JSON.stringify(result);
            let resultObject = JSON.parse(result);

            resultObject = updateResponseObject(resultObject[nuskin.account.GLOBAL_AUTH_RETURN_OBJECT]);

            //remove taiwan cart cookies
            if (document.URL.indexOf("zh_TW") !== -1) {
                storage(keys.LOCAL_ORDER_LIST_NS, null);
                storage(keys.CURRENT_ORDER, null);
                storage(keys.ORDER_LIST, null);
            }

            // Set login time.
            resultObject.loginTime = new Date().getTime();

            thisAM.currentData = resultObject;
            //set the cookie to initialize the "session"
            UserService.setUser(resultObject);
            UserService.setLoggedIn(true);
            //remove the sponsorId cookie if it is set
            $.cookie(keys.SPONSOR_ID, null, {path:'/', expires: -1});
            AuthenticationService.generateMecCookies();
            loadVolumeData();
            events.publish(events.authentication.VALID, [resultObject]);
        };

        let qualifiedCampaignsReturnHandler = function(result) {
            if (result != 'error') {
                if (result && result.length > 0) {
                    let resultObject = JSON.parse(result);
                    let campaigns = resultObject.campaigns;
                    let campaignString = "";
                    for (let i=0; i < campaigns.length; i++) {
                        campaignString+=campaigns[i]+" ";
                    }
                    if (!campaignString) {
                        campaignString = 'NONE'; // will never be empty
                    }
                    CQ_Analytics.ProfileDataMgr.setProperty('qualifiedCampaigns', campaignString);
                    CQ_Analytics.ClickstreamcloudMgr.fireEvent("loadcampaigns");
                }
            }
        };

        let accountCreateReturnHandler = function(user, result) {
        };

        function getQualifiedCampaigns(sapId) {
            let parameters = {};
            parameters.sapId = sapId;
            $.ajax({
                type: "GET",
                url:  "/signupApp/service/qualifiedCampaigns/"+util.countryCode+"/"+sapId,
                contentType: "text/plain; charset=utf-8",
                success: qualifiedCampaignsReturnHandler,
                error: function(result) {
                    $('#errorDiv').text("Error:"+result);
                }
            });
        }

        // define the loadSegments function for modify the Office link
        function determineDashboardUrl() {
            //alert("In determineDashboardUrl");
            if (UserService.isLoggedIn()) {
                //alert("In loggedIn");
                let index = -1;
                if (typeof(CQ_Analytics) != "undefined" && CQ_Analytics.SegmentMgr) {
                    for (index=0; index<nuskin.account.AccountManager.segmentMapping.length; index++) {
                        if (CQ_Analytics.SegmentMgr.resolve(nuskin.account.AccountManager.segmentMapping[index].segment)) {
                            break;
                        }
                    }
                }

                //alert("index=" + index);
                let dest;
                if ((index > -1) && (index < nuskin.account.AccountManager.segmentMapping.length)) {
                    dest = nuskin.account.AccountManager.segmentMapping[index].dashboard;
                } else {
                    dest = nuskin.account.AccountManager.defaultDashboardUrl;
                }

                nuskin.account.AccountManager.dashboardUrl = cleanupUrl(dest);
            } else {
                //alert("NOT loggedIn");
                nuskin.account.AccountManager.dashboardUrl = "";
            }
            //alert("this.dashboardUrl=" + this.dashboardUrl);
        }

        function cleanupUrl(url) {
            if (url) {
                // if the url starts with '/' and not end with .html, append .html
                if ((url.charAt(0) == '/') && (url.indexOf(".html", url.length - 5) < 0)) {
                    url += ".html";  // add the .html for the mapping
                }
                if (url.match("^http[s]*://") == null) {
                    url = window.location.protocol + '//' + window.location.host + (url.match("^/") == "/" ? "" : "/") + url;
                }
            }
            return url;
        }

        function handleForeignDashboard(userCC) {
            let defaultLoginRoute = true;
            // it should be defined in the head.jsp with the ssi of backOfficeConf
            if ((typeof(officeSettings) != "undefined") && officeSettings) {
                nuskin.account.AccountManager.dashboardUrl = "";
                if (userCC) {
                    // check if the site's countryCode is in the group with the user's countryCode....
                    // if not in the group, no redirect, but change the office link to user's country

                    let userOfficeSettings = findUserOfficeSettings(officeSettings, userCC);
                    let siteLocaleStr = util.languageCode + "_" + util.countryCode;
                    let siteOfficeSettings = officeSettings[siteLocaleStr];
                    if (userOfficeSettings) {
                        // dashboard disabled that means we are going to myOffice
                        if (!userOfficeSettings["enabled"]) {
                            if (siteOfficeSettings && siteOfficeSettings["enabled"]) {
                                // assuming the the dashboard will handle the redirect... (Ian should take care of redirecting to myoffice)
                                nuskin.account.AccountManager.dashboardUrl = siteOfficeSettings["dashboardUrl"];
                            } else {
                                // this should never hit (because if the siteOfficeSettings has to be enable in order to call handleDashboard...
                                nuskin.account.AccountManager.dashboardUrl = userOfficeSettings["myOfficeUrl"];
                            }
                        } else {
                            if (siteOfficeSettings) {
                                // we will go to the site dashboard for it to display any popup
                                nuskin.account.AccountManager.dashboardUrl = siteOfficeSettings["dashboardUrl"];
                                // if the same group, we are going to set the dashboard of the site, and redirect there
                                if (siteOfficeSettings["group"] && (siteOfficeSettings["group"] == userOfficeSettings["group"])) {
                                    if (util.useBackOfficeDashboardRedirect && util.redirectToDashboard) {
                                        // there is a little twist that we need to take care of the auto-redirect
                                        // because we only want to go to dashboard if distributor
                                        // (originally it should be handled by the segmentation, but we did not use it at all for now)
                                        let user = UserService.getUser();
                                        if (user && user.isDistributor()) {
                                            defaultLoginRoute = false;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

                if (nuskin.account.AccountManager.dashboardUrl) {
                    nuskin.account.AccountManager.dashboardUrl = cleanupUrl(nuskin.account.AccountManager.dashboardUrl);
                }
            }

            return defaultLoginRoute;
        }

        function findUserOfficeSettings(settings, userCC) {
            let rv = null;

            for (let key in settings) {
                if (settings.hasOwnProperty(key)) {
                    // For example, "en_US" is the key, and "US" is the userCC
                    if (key.indexOf(userCC) >= 0) {
                        if (rv == null) {
                            rv = settings[key];
                        } else {
                            // override the rv if the language is en
                            if (key.indexOf("en") == 0) {
                                rv = settings[key];
                            }
                        }
                    }
                }
            }

            return rv;
        }

        this.clearSessionVariables = function() {
            if(nuskin.shop) {
                nuskin.shop.setFavoritesCookie(null);
            }
            storage.removeItem(keys.ORDER_LIST);
            storage.removeItem(keys.CURRENT_ORDER);
            sessionStorage.removeItem(keys.EVENT_FORM_DATA);
        };

        //soft logout that will not redirect page. Used for guest checkout
        this.softLogout = function () {
            thisAM.clearSessionVariables();
            BuyerCookieService.resetBuyerCookie();
            UserService.resetUserStorage();
            localStorage.removeItem("shoppingCart");
            localStorage.removeItem("summerPromoCart");
            $.cookie(keys.SPONSOR_ID, null, { path: '/', expires: -1 });
            thisAM.currentData = null;
        };

        this.resetLoginCookies = function() {
            thisAM.clearSessionVariables();
            BuyerCookieService.resetBuyerCookie();
            //Clear orders from localStorage
            storage.setItem(ORDER_STORAGE_KEY, null);
            storage.setItem(ORDER_PREFS_STORAGE_KEY, null);
            UserService.resetUserStorage();
            thisAM.setAfterLoginUrl(null);
        };

        let logoutHandler = function() {
            thisAM.resetLoginCookies();
            localStorage.removeItem("shoppingCart");
            localStorage.removeItem("summerPromoCart");
            events.publish(events.authentication.LOGOUT);
            if (thisAM.currentData) {
                if (typeof CQ_Analytics !== 'undefined') {
                    CQ_Analytics.ProfileDataMgr.setProperty('qualifiedCampaigns', '');
                }
                nuskin.account.AccountManager.clearCampaignsVisited(); // clears the cookie

                //someone was actually logged in--need to take care of some things
                $.cookie(keys.SPONSOR_ID, null, {path:'/', expires: -1});
                thisAM.currentData = null;

                if (util.useProfiles) {
                    if (typeof CQ_Analytics !== 'undefined') {
                        CQ_Analytics.ProfileDataMgr.loadProfile('anonymous');
                    }
                }

                if (thisAM.afterLogoutRedirect) {
                    if (!util.isEcom3()) {
                        $.ajax({
                            url: util.shopAppUrl+"clear-session",
                            type: "GET",
                            complete:  function() {
                                window.location = thisAM.afterLogoutRedirect;
                            }
                            //                        ,error: $.ajaxWrapper.handleDefaultAjaxErrors
                        });
                    } else {
                        events.publish(events.authentication.LOGOUT_LEGACY, [
                            {}
                        ]);
                        window.location = thisAM.afterLogoutRedirect;
                    }
                } else {
                    //publish the event
                    events.publish(events.authentication.LOGOUT_LEGACY, [
                        {}
                    ]);
                }
            }
        };

        let smartAuthReturnHandler = function(result, silent) {
            if (silent) {
                silentAuthReturnHandler(result);
            } else {
                authReturnHandler(result);
            }
        };

        var updateResponseObject = function(resultObject) {
            resultObject.eid = resultObject.encryptedId;
            resultObject.lastName = resultObject.name.substring(0,resultObject.name.indexOf(',')).trim();
            resultObject.firstName = resultObject.name.substring(resultObject.name.indexOf(',') + 1).trim();
            resultObject.accountType = resultObject.accountType.toString();     // We have several places in code that expect accountType to be a string
            resultObject.countryCd = resultObject.countryCd;
            return resultObject;
        };

        var authReturnHandler = function(result) {
            result = JSON.stringify(result);
            let resultObject = JSON.parse(result);
            let nsConfig = ConfigService.getMarketConfig();

            if (resultObject.hasOwnProperty(nuskin.account.GLOBAL_AUTH_RETURN_OBJECT)) {
                resultObject = updateResponseObject(resultObject[nuskin.account.GLOBAL_AUTH_RETURN_OBJECT]);
                if (util.getValue("nuskin.configuration.checkWhitelist",false)) {
                    let extendedAccountUrl = util.getValue("nuskin.configuration.nsurl_extendedAccount", "/account-service/api/v1/account/extended/");
                    $.ajax({
                        type: "GET",
                        url: extendedAccountUrl + resultObject.id,
                        data: {"cntryCd": util.countryCode},
                        //Todo replace basic auth with token auth
                        headers: {"Authorization": "Basic Ym9iOmJvYnNwYXNzd29yZA==","client_id": nsConfig.checkout.clientId,"client_secret": nsConfig.checkout.clientSecret}
                    }).done(function (response,xhr) {
                        if (response.BeReadResponse.PPACountries && response.BeReadResponse.PPACountries.indexOf(util.countryCode) < 0) {
                            events.publish(events.authentication.INVALID_SHOPPING_COUNTRY, [resultObject]);
                        } else {
                            processLoginResponse(resultObject);
                        }
                    }).fail(function () {
                        processLoginResponse(resultObject);
                    });
                } else {
                    processLoginResponse(resultObject);
                }
            } else {
                // todo Remove this check once we get rid of the login popup.
                if (window.location.href.indexOf("/login.html") === -1 && typeof(Login) !== "undefined") {
                    events.publish(events.authentication.INVALID);
                }
                else {
                    events.publish(events.authentication.INVALID_NEW_LOGIN_PAGE);
                }
            }
        };

        let lookupAvailablePoints = function() {
            let nsConfig = ConfigService.getMarketConfig();
            if(nsConfig.enablePointsRedemption){
                var pointsPromise = $.ajax({
                    type: "GET",
                    url: nsConfig.nsurl_sapAdrStatusService + thisAM.currentData.id,
                    data: {"countryGroup": util.countryCode, "eid": thisAM.currentData.eid},
                    contentType: "text/plain; charset=utf-8",
                    beforeSend: function(xhr) {
                        xhr.setRequestHeader("client_id", nsConfig.checkout.clientId);
                        xhr.setRequestHeader("client_secret", nsConfig.checkout.clientSecret);
                    }
                });
            } else {
                let deferred = new $.Deferred();
                deferred.resolve();
                return deferred;
            }

            pointsPromise.done(function(response) {
                // AEM-8414 rudist still has the login popup after logging in
                // Basically, there is a javascript error for ADRPoints is undefined
                // Need to check if ADRPoints does NOT exists before doing the loop
                if (response.ADRMemberStatusResponse && response.ADRMemberStatusResponse.ADRPoints) {
                    $.each(response.ADRMemberStatusResponse.ADRPoints, function(key, value) {
                        if(value.CountryCode === util.countryCode) {
                            let user = UserService.getUser();
                            user.availablePoints = value.AvailablePoints;
                            UserService.setUser(user);
                        }
                    });
                }
            });

            pointsPromise.fail(function (error) {
                thisAM.currentData.availablePoints = 0;
                UserService.setUser(thisAM.currentData);
            });

            return pointsPromise;
        };

        var processLoginResponse = function(resultObject) {
            // Set login time.
            resultObject.loginTime = new Date().getTime();

            thisAM.currentData = resultObject;
            saveUserBuyerCookieForEcom3(thisAM.currentData);

            //set the cookie to initialize the "session"
            UserService.setUser(resultObject);

            UserService.setLoggedIn(true);

            //remove the sponsorId cookie if it is set
            $.cookie(keys.SPONSOR_ID, null, {path: '/', expires: -1});

            //remove taiwan cart cookies
            if (document.URL.indexOf("zh_TW") !== -1) {
                storage.setItem(keys.LOCAL_ORDER_LIST_NS, null);
                storage.setItem(keys.CURRENT_ORDER, null);
                storage.setItem(keys.ORDER_LIST, null);
            }

            let userID = resultObject.id;


            // TODO move to the 'profile' or 'personalization' module
            if (util.useProfiles && CQ_Analytics && CQ_Analytics.ProfileDataMgr) {

                let lastInitial = lastName.charAt(0);
                let path = "/home/users/crew/" + lastInitial;

                let loaded = CQ_Analytics.ProfileDataMgr.loadProfile(userID);
                if (!loaded) {
                    // create the account
                    $.ajax({
                        type: "GET",
                        url: "/apps/global/services/accountCreate.html",
                        data: {"user": userID, "familyName": resultObject.lastName, "givenName": resultObject.firstName, "intermediatePath": path},
                        contentType: "text/plain; charset=utf-8",
                        success: accountCreateReturnHandler(userID),
                        error: function (result) {
                            $('#errorDiv').text("Error:" + result);
                        }
                    });
                }
            }

            //run the PNP check
            // TODO shouldn't be defined in here - has nothing to do with authentication
            let returnUrl;
            if (window.location.href.indexOf("/login.html") !== -1 && typeof(Login) !== "undefined"){
                let user = UserService.getUser();

                // Get the url from the login dialog.
                returnUrl = Login.getRedirectUrlLoginSuccess();
                if (user && user.eid){
                    returnUrl = util.Url.addParam(returnUrl, 'eid', user.eid);
                }
            }
            else{
                returnUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
            }

            if (window.location.hash != "#showLogin" && window.location.hash != "#forgotPasswordLink" && window.location.hash != '#/' && window.location.hash != '#/cart') {
                returnUrl += window.location.hash;
            }
            let afterLoginUrl = thisAM.getAfterLoginUrl();
            if (afterLoginUrl) {
                if (afterLoginUrl.newWindow) {
                    $.cookie(keys.NEW_WINDOW_URL, afterLoginUrl.url, {path: '/'});
                } else {
                    returnUrl = afterLoginUrl.url;
                    util.redirectToDashboard = false;
                }
                thisAM.setAfterLoginUrl(null);
            }

            try {
                if (nuskin.account.AccountManager.isPreferredCustomer() && util.usePreferredCustomerRedirect) {
                    window.location = util.preferredCustomerRedirectURL;
                }
            } catch(e) {}

            events.publish(events.authentication.VALID,[resultObject]);

            if (!initialized) {
                initialized = true;
                events.setValue(events.account.INIT_COMPLETE);
            }

            if (document.URL.indexOf("zh_TW") < 0) {
                AuthenticationService.generateMecCookies();
            }
            // TODO loading volume data should not happen in the auth return handler...it should happen in a separate module
            loadVolumeData().then(function () {  // don't redirect until volume data loaded
                let pointsPromise = lookupAvailablePoints();
                pointsPromise.always(function () {
                    redirectToDestination(userID, returnUrl);
                });
            });
        };

        // TODO This function should listen to the 'nuskin.events.authentication.VALID' and then execute
        var redirectToDestination = function(userID, returnUrl) {
            if (!nuskin.account.AccountManager.isEmeaSignup()) {
                let resetPassword = window.location.href.indexOf('resetPassword=true') !== -1;

                if (resetPassword) {
                    if (returnUrl.indexOf('resetPassword=true') === -1) {
                        returnUrl += '?resetPassword=true';
                    }
                    thisAM.gotoDestination(returnUrl);
                } else {
                    if (util.getCurrentPageName().toLowerCase() !== "home") {
                        util.redirectToDashboard = false;
                    }

                    //don't do a redirect if we are on the agelocME assessment app
                    if (!util.MobileUtils.isPhoneGap()) {
                        // it will setup the nuskin.account.AccountManager.dashboardUrl
                        let defaultLoginRoute = nuskin.account.AccountManager.handleDashboardLogic(userID);
                        if (defaultLoginRoute) {
                            thisAM.gotoDestination(returnUrl);
                        } else {
                            thisAM.gotoDestination(nuskin.account.AccountManager.dashboardUrl);
                        }
                    } else {
                        events.publish(events.authentication.AGELOCME_LOGIN);
                    }
                }
            }
        };

        var loadVolumeData = function() {
            // var nsConfig = ConfigService.getMarketConfig(),
            //     volumePromise;
            //
            // let volumeAccountUrl = util.getValue("nuskin.configuration.nsurl_accountService", "/account-service/api/v1/account");
            // volumeAccountUrl += "/simple/" + thisAM.currentData.id;
            // volumePromise = $.ajax({
            //     type: "GET",
            //     url: volumeAccountUrl,
            //     headers: {"client_id": nsConfig.checkout.clientId,"client_secret": nsConfig.checkout.clientSecret},
            //     data: {addVg: true, eid: thisAM.currentData.eid}
            // });
            //
            // //onlyUsedTogetCircleGroupLeader
            // volumePromise.done(function(response) {
            //     thisAM.currentData.isCircleGroupLeader = response.SimpleAccount.circleGroupLeader;
            //     UserService.setUser(thisAM.currentData);
            //     saveUserBuyerCookieForEcom3(thisAM.currentData);
            //     events.publish(events.account.VOLUME_ADDED, [thisAM.currentData]);
            // });
            //
            // volumePromise.fail(function (error) {
            //     console.log(error);
            // });

            let vgDistInfoPromise = VGDistInfoService.getVGDistInfo();
            vgDistInfoPromise.then((distInfo) => {
                thisAM.currentData.volumes = VGDistInfoService.formatVolumeData(distInfo.data.volume);
                thisAM.currentData.highestRank = distInfo.data.highRank;
                thisAM.currentData.displayName = distInfo.data.displayName;
                UserService.setUser(thisAM.currentData);
                saveUserBuyerCookieForEcom3(thisAM.currentData);
                events.publish(events.account.VOLUME_ADDED, [thisAM.currentData]);
            }).catch((error) => {
                console.error("VGDistInfoSevice Exception: ", error);
            });

            return vgDistInfoPromise;
        };

        // Exposed this function outside
        this.handleDashboardLogic = function(user) {
            // Need to check if it is on the flow.....
            // all the different condition right here
            let defaultLoginRoute = true;

            if (util.useBackOfficeDashboard) {
                let userCountryCode = extractISOCountryCode(user);
                let isLocalUser = (util.countryCode == userCountryCode);
                // Do this with the normal flow...
                if (isLocalUser) {
                    determineDashboardUrl();
                    if (util.useBackOfficeDashboardRedirect && util.redirectToDashboard) {
                        // there is a little twist that we need to take care of the auto-redirect
                        // because we only want to go to dashboard if distributor
                        // (originally it should be handled by the segmentation, but we did not use it at all for now)
                        var user = UserService.getUser();
                        if (user && user.isDistributor()) {
                            defaultLoginRoute = false;
                        }
                        /* Somehow, the clickstreamCloud may be unavailable due to the timing issue, but should be OK for now
                         if (typeof(CQ_Analytics) != "undefined" && CQ_Analytics.ClickstreamcloudMgr) {
                         //   var destination = nuskin.account.AccountManager.dashboardUrl;
                         if (CQ_Analytics.ClickstreamcloudMgr.areStoresLoaded) {
                         defaultLoginRoute = false;
                         } else {
                         CQ_Analytics.ClickstreamcloudMgr.addListener("storesloaded", function() {
                         defaultLoginRoute = false;
                         });
                         }
                         }
                         */
                    }
                } else {
                    defaultLoginRoute = handleForeignDashboard(userCountryCode);
                }
            }

            return defaultLoginRoute;
        };

        function extractISOCountryCode(userId) {
            // we have some weird ID mapping, UKxxxxxxx maps to GB
            let mapping = {"UK":"GB", "AS":"AU", "JA":"JP"};

            // According to the business, the user prefix determines the user's country of origin
            // if NOT, he/she must call in to change it!!!!!
            let cc = userId.substring(0,2);
            if (mapping[cc] != null) {
                cc = mapping[cc];
            }

            return cc;
        }

        function saveUserBuyerCookieForEcom3(userJsonObj) {
            if (util.isEcom3()) {
                // save the user to cookie
                let user = User;
                user.init(userJsonObj);

                UserService.setUser(user);

                // save the buyer to cookie
                let buyer = Buyer;
                buyer.init(user);

                BuyerCookieService.setBuyer(buyer);
            }
        }

        this.anonymousDestination = function(returnUrl) {
            returnUrl = escape(returnUrl);
            window.location= returnUrl;
        };

        this.gotoDestination = function(returnUrl) {
            let params = thisAM.getAfterLoginParams() || {};

            // if (params.hideLogin) {
            events.publish(events.authentication.HIDE_LOGIN_POPUP);
            // }
            let nsConfig = ConfigService.getMarketConfig();
            if (params.skipSignonRedirect || util.getValue(nsConfig.skipSignonRedirect, false)) {
                window.location = returnUrl;
            } else {
                returnUrl = escape(returnUrl);
                let authUrl = RunConfigService.getRunConfig().baseUrl + "/signon/pnp/form.do?pnpSapId="+thisAM.currentData.id+"&pnpAcceptURL="+returnUrl+"&pnpRejectURL="+returnUrl+"&pnpErrorURL="+returnUrl;
                window.location = authUrl;
            }
        };

        // non cas
        this.pingReturnHandler = function(result){
            let resultObject = JSON.parse(result);

            let campaigns = "";
            let pinLevel = "";
            if (typeof CQ_Analytics !== 'undefined') {
                campaigns = CQ_Analytics.ProfileDataMgr.getProperty('qualifiedCampaigns');
                pinLevel = CQ_Analytics.ProfileDataMgr.getProperty('pinLevel');
            }

            if(!resultObject.eid) {
                thisAM.logout();
                return;
            }

            // Stuff the new eid into the user.
            let user = UserService.getUser();

            if (typeof resultObject != "undefined" && resultObject.hasOwnProperty("eid")) {
                user.eid = resultObject.eid;
            }
            UserService.setUser(user);


            if(thisAM.currentData) {
                thisAM.currentData.eid = resultObject.eid;
                saveUserBuyerCookieForEcom3(thisAM.currentData);
            }

            if(!initialized) {
                initialized = true;
                events.setValue(events.account.INIT_COMPLETE);

                if (util.useBackOfficeDashboard && !pinLevel) {
                    //alert("In the logic, new pinLevel=" + nuskin.account.AccountManager.currentData.highestRank);
                    try {
                        if (typeof CQ_Analytics !== 'undefined') {
                            CQ_Analytics.ProfileDataMgr.setProperty('pinLevel', parseInt(nuskin.account.AccountManager.currentData.highestRank));
                        }
                    } catch (e) {
                        if (typeof CQ_Analytics !== 'undefined') {
                            CQ_Analytics.ProfileDataMgr.setProperty('pinLevel', -1);
                        }
                    }
                }

                if (nuskin.configuration.useCampaigns && !campaigns) {
                    let id = nuskin.account.AccountManager.currentData.id;
                    getQualifiedCampaigns(id);
                }

                if (util.useProfiles) {
                    if (typeof CQ_Analytics !== 'undefined') {
                        let loaded = CQ_Analytics.ProfileDataMgr.loadProfile(nuskin.account.AccountManager.currentData.id);
                    }
                }
            }

            // This is used to indicate if a ping is completed (using jQuery)
            events.publish(events.authentication.PING_COMPLETE, [thisAM.currentData]);
        };

        this.setAfterLoginParams = function(params) {
            if (params == null) {
                $.cookie(keys.AFTER_LOGIN_PARAMS, null, {path:'/', expires: -1});
            } else {
                let paramsObj = {
                    hideLogin: params.hideLogin,
                    skipSignonRedirect: params.skipSignonRedirect
                };

                $.cookie(keys.AFTER_LOGIN_PARAMS, JSON.stringify(paramsObj), {path: '/'});
            }
        };

        this.getAfterLoginParams = function() {
            let cookieString = $.cookie(keys.AFTER_LOGIN_PARAMS);

            if (cookieString) {
                return JSON.parse(cookieString);
            }
            return null;
        };

        this.setAfterLoginUrl = function(url, newWindow) {
            if (typeof url === "undefined" || url === null) {
                $.cookie(keys.AFTER_LOGIN_URL, null, {path:'/', expires: -1});
            } else {
                if (!newWindow) {
                    newWindow = false;
                }
                if (url.match("^http[s]*://") == null) {
                    url = window.location.protocol + '//' + window.location.host + (url.match("^/") == "/" ? "" : "/") + url;
                }
                let urlObject = {};
                urlObject.url = url;
                urlObject.newWindow = newWindow;
                $.cookie(keys.AFTER_LOGIN_URL, JSON.stringify(urlObject), {path:'/'});
            }
        };

        this.getAfterLoginUrl = function() {
            let cookieString = $.cookie(keys.AFTER_LOGIN_URL);
            if (cookieString) {
                return JSON.parse(cookieString);
            }
            return null;
        };

        this.anonyousSignin = function() {
            if (thisAM.currentData) {
                UserService.resetUserStorage();
                $.cookie(keys.SPONSOR_ID, null, {path:'/', expires: -1});
                thisAM.currentData = null;

                events.publish(events.authentication.LOGOUT_LEGACY, [
                    {}
                ]);
                events.publish(events.authentication.LOGOUT);
            }
            let anonymousCookie = '{"id": "-","name": "User, New","localName": "User, New","email": "newUser@nuskin.com","accountType": "10","countryCd": "US","priceType": "WHL","customerType": "DISTRIBUTOR","encryptedId": "-","eid":"-"}';
            //            authReturnHandler(anonymousCookie);
            silentAuthReturnHandler(anonymousCookie);
        };

        this.authenticate = function(username, password) {
            if (thisAM.currentData) {
                UserService.resetUserStorage();
                $.cookie(keys.SPONSOR_ID, null, {path:'/', expires: -1});
                thisAM.currentData = null;
                events.publish(events.authentication.LOGOUT_LEGACY, [
                    {}
                ]);
                events.publish(events.authentication.LOGOUT);
            }
            //delete OPSMode cookie if user manually logs in Needs to be removed from subdomain example .nusinops.com
            let domain = location.host.substr(location.host.indexOf("."));
            $.cookie("custtype", null, {path:'/', domain: domain, expires: -1});

            let parameters = {};
            parameters.username = Base64.encode(username);
            parameters.password = Base64.encode(password);

            let nsConfig = ConfigService.getMarketConfig();
            if (document.URL.indexOf("zh_TW") !== -1 && !nsConfig.taiwan.enableGlobalAuth) {
                let returnUrl = window.location.toString().replace(".loginError", "");
                let authenticateUrl = nsConfig.taiwan.taiwanLoginUrl + '?furl=' + returnUrl + '&username=' + username + '&password=' + password;
                window.location = authenticateUrl;
            } else if ($.support.cors) {
                let encodedAuthCredentials = Base64.encode(username + ":" + password);
                let globalAuthUrl = util.getValue("nuskin.configuration.globalAuthUrl", "https://www.nuskin.com/simpleBE/api/v1/be");
                $.ajax({
                    url: globalAuthUrl,
                    type: "GET",
                    crossDomain: true,
                    withCredentials: true,
                    dataType: "json",
                    beforeSend: function(xhr) {
                        xhr.setRequestHeader("Authorization", "Basic " + encodedAuthCredentials);
                        xhr.setRequestHeader("client_id", nsConfig.checkout.clientId);
                        xhr.setRequestHeader("client_secret", nsConfig.checkout.clientSecret);
                    }
                }).done(authReturnHandler
                ).fail(function(xhr) {
                    if (window.toggleLoginDisable) {
                        window.toggleLoginDisable();
                    }
                    if (BrowserDetection.isIE() && BrowserDetection.browserVersion <= 10 && document.URL.indexOf("zh_TW") !== -1) {
                        thisAM.checkStatus(encodedAuthCredentials);
                    } else {
                        // todo Remove this check once we get rid of the login popup.
                        if (window.location.href.indexOf("/login.html") !== -1 && typeof(Login) !== "undefined"){
                            events.publish(events.authentication.INVALID_NEW_LOGIN_PAGE, xhr);
                        } else {
                            events.publish(events.authentication.INVALID, xhr);
                        }
                    }
                });
            }
        };

        //Service used to get the failed status of a authentication. This is required for IE 10 because it does not allow a response body on a CORS call with a 401 response
        this.checkStatus = function(encodedAuthCredentials) {
            let globalStatusURL = util.getValue("nuskin.configuration.globalStatusUrl", "https://www.nuskin.com.tw/simpleBe/api/v1/status");
            let nsConfig = ConfigService.getMarketConfig();
            $.ajax({
                url: globalStatusURL,
                type: "GET",
                crossDomain: true,
                withCredentials: true,
                dataType: "json",
                beforeSend: function(xhr) {
                    xhr.setRequestHeader("Authorization", "Basic " + encodedAuthCredentials);
                    xhr.setRequestHeader("client_id", nsConfig.checkout.clientId);
                    xhr.setRequestHeader("client_secret", nsConfig.checkout.clientSecret);
                }
            }).done(function(data) {
                events.publish(events.authentication.STATUS, data);
            }).fail(function(xhr) {
                console.log("Error checking login status: " + xhr);
            });
        };

        this.authenticateWithEid = function(eid, silent) {
            if (thisAM.currentData || this.isLoggedIn()) {
                // null out both cookies so that the cookie processing doesnt happen in the onload
                UserService.resetUserStorage();
                $.cookie(keys.SPONSOR_ID, null, {path:'/', expires: -1});
                events.publish(events.authentication.LOGOUT);
                thisAM.currentData = null;
                if(!this.isLoggedIn) {
                    events.publish(events.authentication.LOGOUT_LEGACY, [
                        {}
                    ]);
                }
            }

            if ($.support.cors) {
                let globalAuthURL = util.getValue("nuskin.configuration.globalAuthEIDUrl", "https://www.nuskin.com/simpleBe/api/eid/be") + "?eid=" + eid;
                let nsConfig = ConfigService.getMarketConfig();
                $.ajax({
                    url: globalAuthURL,
                    type: "GET",
                    beforeSend: function(xhr) {
                        xhr.setRequestHeader("client_id", nsConfig.checkout.clientId);
                        xhr.setRequestHeader("client_secret", nsConfig.checkout.clientSecret);
                    }
                }).done(function(data) {
                    try {
                        data.businessEntity.encryptedId = eid;
                    } catch(e) {}
                    if (silent) {
                        silentAuthReturnHandler(data);
                    } else {
                        authReturnHandler(data);
                    }
                }).fail(function(data) {
                    events.publish(events.authentication.INVALID, JSON.parse(data.responseText));
                });
            }
        };

        this.authenticate2HourEid = function(eid, silent) {
            if (thisAM.currentData) {
                // null out both cookies so that the cookie processing doesnt happen in the onload
                UserService.resetUserStorage();
                $.cookie(keys.SPONSOR_ID, null, {path:'/', expires: -1});
                events.publish(events.authentication.LOGOUT);
                thisAM.currentData = null;
                if(!this.isLoggedIn) {
                    events.publish(events.authentication.LOGOUT_LEGACY, [
                        {}
                    ]);
                }
            }

            if ($.support.cors) {
                let globalAuthURL = util.getValue("nuskin.configuration.globalAuthEIDUrl", "https://www.nuskin.com/simpleBe/api/eid/be") + "?eid=" + eid + "&context=resetPassword";
                let nsConfig = ConfigService.getMarketConfig();
                $.ajax({
                    url: globalAuthURL,
                    type: "GET",
                    beforeSend: function(xhr) {
                        xhr.setRequestHeader("client_id", nsConfig.checkout.clientId);
                        xhr.setRequestHeader("client_secret", nsConfig.checkout.clientSecret);
                    }
                }).done(function(data) {
                    if (silent) {
                        silentAuthReturnHandler(data);
                    } else {
                        authReturnHandler(data);
                    }
                }).fail(function(data) {
                    events.publish(events.authentication.INVALID, JSON.parse(data.responseText));
                    let afterLoginURL = thisAM.getAfterLoginUrl().url;
                    let localePage = afterLoginURL.substring(0, afterLoginURL.indexOf("_") + 3);
                    window.location =localePage + "/shop/error.eidexpirederror.html"
                });
            }
        };

        this.setCampaignsVisited = function(value) {
            $.cookie(keys.CAMPAIGNS_VISITED, value, {path:'/'});
        };

        this.getCampaignsVisited = function() {
            let rv = $.cookie(keys.CAMPAIGNS_VISITED);
            if (!rv || rv == undefined ||  typeof(rv)  == "undefined") {
                rv = '';
            }
            return rv;
        };

        this.clearCampaignsVisited = function() {
            $.cookie(keys.CAMPAIGNS_VISITED, null, {path:'/', expires: -1});
        };

        //TODO convert simpleping and ping to one call
        this.simplePing = function() {
            if (thisAM.currentData && !nuskin.account.AccountManager.isEmeaSignup()) {
                return choosePing();
            }
        };

        this.ping = function() {
            if (typeof(useSapIdLogin) != "undefined" && useSapIdLogin) {
                //sapIdLogin.ping();
                // do not need to ping at all
            } else {
                if (document.URL.indexOf("zh_TW") !== -1 && thisAM.useTaiwanLogin()) {
                    let nsConfig = ConfigService.getMarketConfig();
                    //TODO: Convert to jQuery
                    // Need to us dojo to handle cross domain.
                    let deferred = dojox.io.windowName.send(
                        "POST",
                        {url:nsConfig.taiwan.taiwanPingUrl,handleAs:'text'});

                    deferred.addCallback(function(result) {
                        // don't ask me why I have to do the whole '<!-- framPath...' check...
                        if (result && result != '<!--framePath //<!--frame1-->-->' && result.length > 0) {
                            if (thisAM.currentData) {
                                thisAM.currentData.eid = JSON.parse(result).eid;
                            }

                            if (!thisAM.initialized) {
                                thisAM.initialized = true;
                                events.setValue(events.account.INIT_COMPLETE);
                            }
                            events.publish(events.authentication.PING_COMPLETE);
                        } else {
                            thisAM.logout();
                        }
                    });

                }
                if (thisAM.currentData && !nuskin.account.AccountManager.isEmeaSignup()) {
                    choosePing();
                }
            }
        };

        $.subscribe(events.authentication.PING, function() {
            thisAM.simplePing();
        });

        function choosePing() {
            let nsConfig = ConfigService.getMarketConfig();

            if (nsConfig.useAwsRemintService) {
                return awsRemint(`${nsConfig.awsUrl}/remint/v1`);
            } else {
                return legacyPing(nsConfig.globalAuthPingUrl);
            }

        }

        function awsRemint(url) {
            let nsConfig = ConfigService.getMarketConfig(),
                dataObject = {"eid":thisAM.currentData.eid};

            return $.ajax({
                url: url,
                type: 'GET',
                data: dataObject,
                crossDomain: true,
                dataType: 'json',
                beforeSend: function(xhr) {
                    xhr.setRequestHeader("client_id", nsConfig.checkout.clientId);
                    xhr.setRequestHeader("client_secret", nsConfig.checkout.clientSecret);
                }
            }).done(function(resultObject) {
                try {
                    let currentUser = UserService.getUser();

                    thisAM.eid = currentUser.eid = resultObject.businessEntity.encryptedId;
                    currentUser.pingTimestamp = new Date().getTime();
                    UserService.setUser(currentUser);
                    if (!thisAM.initialized) {
                        thisAM.initialized = true;
                        events.setValue(events.account.INIT_COMPLETE);
                    }
                    events.publish(events.authentication.PING_COMPLETE);
                } catch (err) {
                    console.log(err);
                    if (!resultObject.hasOwnProperty(nuskin.account.GLOBAL_AUTH_RETURN_OBJECT)) {
                        // only logout if no eid was returned.
                        thisAM.logout();
                    }
                }
            }).fail(function(xhr) {
                //If the request wasn't canceled.
                if (xhr.status === 401) {
                    setUserTimedOut(xhr);
                    thisAM.logout();
                } else {
                    //If the request was aborted a redirect probably occurred during the ping request so we don't want to log the user out.
                    console.warn("Ping request was aborted likely because of a redirect");
                }
            });
        }

        function legacyPing(globalAuthPing) {
            let dataObject = {"eid":thisAM.currentData.eid};
            let nsConfig = ConfigService.getMarketConfig();
            return $.ajax({
                url: globalAuthPing,
                type: "GET",
                data: dataObject,
                crossDomain: true,
                dataType: "json",
                beforeSend: function(xhr) {
                    xhr.setRequestHeader("client_id", nsConfig.checkout.clientId);
                    xhr.setRequestHeader("client_secret", nsConfig.checkout.clientSecret);
                }
            }).done(function(resultObject) {
                if (resultObject) {
                    if (resultObject.hasOwnProperty(nuskin.account.GLOBAL_AUTH_RETURN_OBJECT)) {
                        resultObject = updateResponseObject(resultObject[nuskin.account.GLOBAL_AUTH_RETURN_OBJECT]);
                        if (thisAM.currentData) {
                            resultObject.pingTimestamp = new Date().getTime();
                            thisAM.currentData = resultObject;
                            let currentUser = UserService.getUser();
                            currentUser.eid = resultObject.eid;
                            currentUser.pingTimestamp = resultObject.pingTimestamp;
                            UserService.setUser(currentUser);
                        }

                        if (!thisAM.initialized) {
                            thisAM.initialized = true;
                            events.setValue(events.account.INIT_COMPLETE);
                        }
                        //loadVolumeData();
                        events.publish(events.authentication.PING_COMPLETE);
                    } else {
                        thisAM.logout();
                    }
                }
            }).fail(function(xhr) {
                //If the request wasn't canceled.
                if (xhr.status === 401) {
                    setUserTimedOut(xhr);
                    thisAM.logout();
                } else {
                    //If the request was aborted a redirect probably occurred during the ping request so we don't want to log the user out.
                    console.warn("Ping request was aborted likely because of a redirect");
                }
            });
        }

        this.TaiwanLogout = function() {
            thisAM.clearSessionVariables();
            UserService.resetUserStorage();
            events.publish(events.authentication.LOGOUT);
            let redirectUrl = "";
            if (thisAM.currentData) {
                //someone was actually logged in--need to take care of some things
                $.cookie(keys.SPONSOR_ID, null, {path:'/', expires: -1});
                thisAM.currentData = null;
                if (thisAM.afterLogoutRedirect) {
                    // just set the cookie for the bridging app
                    // lets not set the cookie here but pass the url on the request
                    let url = thisAM.afterLogoutRedirect;

                } else {
                    //publish the event
                    events.publish(events.authentication.LOGOUT_LEGACY, [
                        {}
                    ]);
                }
            }
            window.location = ConfigService.getMarketConfig().taiwan.taiwanLogoutUrl + '?furl='+window.location.toString();
        };

        this.logout = function() {
            // Clear out the adr override.
            sessionStorage.setItem('ADROverrideID', null);
            sessionStorage.setItem('orderReason', null);
            storage.removeItem(storage.metadata.LOYALTY_DATA);

            //removing cookies created from signin/signup
            let cookieArray = ["USER_PROFILE_JWT", "USER_PROFILE_MIN_INFO", "USER_PROFILE_MASTER_INFO", "SGUP_ROLE_USER", "PAGE_RETURN_URL", "CUST_TO_IND_DIST_RET_PAGE", "GUID", "UUID", "HOST_INFO"];
            for (let i = 0; i < cookieArray.length; i++) {
                document.cookie = cookieArray[i] +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
            }
            localStorage.removeItem("USER_PROFILE_MIN_INFO");
            storage.removeItem(storage.metadata.VIEWED_QUALIFICATION_MODAL);

            if (document.URL.indexOf("zh_TW") !=-1 && thisAM.useTaiwanLogin()) {
                this.TaiwanLogout();
            } else if (typeof(useSapIdLogin) != "undefined" && useSapIdLogin) {
                sapIdLogin.logout();
            } else {
                logoutHandler();
            }

        };

        this.useTaiwanLogin = function() {
            let marketConfig = ConfigService.getMarketConfig();
            return !marketConfig.useGigyaLogin && !marketConfig.taiwan.enableGlobalAuth && document.URL.indexOf("/content/login/corp/") === -1;
        };

        this.logoutThenAuthenticateWithEid = function(eid) {
            UserService.resetUserStorage();
            BuyerCookieService.resetBuyerCookie();
            events.publish(events.authentication.LOGOUT);

            if (document.URL.indexOf("zh_TW") !== -1) {
                $.cookie(keys.LOCAL_ORDER_LIST, null, {path: '/', expires: -1});
            }

            if (thisAM.currentData) {
                CQ_Analytics.ProfileDataMgr.setProperty('qualifiedCampaigns', '');
                nuskin.account.AccountManager.clearCampaignsVisited(); // clears the cookie

                //someone was actually logged in--need to take care of some things
                $.cookie(keys.SPONSOR_ID, null, {path:'/', expires: -1});
                thisAM.currentData = null;

                if (util.useProfiles) {
                    CQ_Analytics.ProfileDataMgr.loadProfile('anonymous');
                }

                if (thisAM.afterLogoutRedirect) {
                    if (!util.isEcom3()) {
                        $.ajax({
                            url: util.shopAppUrl + "clear-session",
                            type: "GET"
                        });
                    }
                    thisAM.authenticateWithEid(eid);
                } else {
                    //publish the event
                    events.publish(events.authentication.LOGOUT_LEGACY, [
                        {}
                    ]);
                    thisAM.authenticateWithEid(eid);
                }
            }
        };

        this.getCachedSponsorId = function() {
            return $.cookie(keys.SPONSOR_ID);
        };

        this.requestLogin = function() {
            events.publish(events.authentication.LOGIN_REQUESTED);
        };

        this.taiwanPingReturn = function(result) {

            if (result) {
                var cookieString = UserService.getUser();
                let user = result;

                if(!user.memberId || user.memberId == '') {
                    if (cookieString) {
                        thisAM.TaiwanLogout();
                    }
                } else {
                    user.firstName =  decodeURIComponent(user.partnerName.replace(/\+/g," "));
                    let memberType = user.memberType;
                    if (memberType == '1') {
                        memberType = '10';
                    }
                    if (memberType == '3') {
                        memberType = '30';
                    }
                    user.accountType = memberType;
                    user.lastName = '';
                    user.id = user.memberId;

                    UserService.setUser(user);
                    thisAM.currentData = user;
                    thisAM.currentData.eid = user.eid;
                    thisAM.initialized = true;
                    events.publish(events.authentication.VALID, [user]);
                }

                if(!initialized) {
                    initialized = true;
                    events.setValue(events.account.INIT_COMPLETE);
                }
                events.publish(events.authentication.PING_COMPLETE);
            } else {
                // shouldnt happen, but just in case
                if (cookieString) {
                    thisAM.TaiwanLogout();
                }
            }
        };

        function setUserTimedOut(response){
            console.log('setUserTimedOut :: response is ... ', response);
            let currentUser = UserService.getUser();
            if (currentUser) {
                storage.setItem(keys.LOGIN_TIMED_OUT, currentUser.pingTimestamp);
            }
        }

        $.subscribe(events.authentication.LOGOUT_LEGACY, function(object) {
            storage.setItem(keys.LOGGING_OUT, Date.now());
        });


        let onLoad = function() {

            let queryString = window.location.search.substring(1);

            if (queryString) {

                let queryObject =  $.getQueryParameters(queryString);

                // check for sponsorId on query string and set it
                let sponsorId = null;

                if (queryObject.pwpId) {
                    sponsorId = queryObject.pwpId;
                } else if (queryObject.siteName) {
                    try {
                        let siteUrl = "www.nsproducts.com";
                        try {
                            let hostNameMode = location.host.split(".")[0];
                            let siteUrlArray = siteUrl.split(".");
                            siteUrl = hostNameMode;
                            for (let i in siteUrlArray) {
                                if(i != 0) {
                                    siteUrl = siteUrl + "." + siteUrlArray[i];
                                }
                            }
                        }catch(exception) {}
                    } catch(e) {}

                }  else if (queryObject.gwpId) {
                    sponsorId = queryObject.gwpId;
                }

                if (sponsorId) {
                    //set the sponsor id cookie
                    $.cookie(keys.SPONSOR_ID, sponsorId, {path:'/'});
                }
            }

            let newWindowUrl = $.cookie(keys.NEW_WINDOW_URL);
            if (newWindowUrl) {
                $.cookie(keys.NEW_WINDOW_URL, null, {path:'/', expires: -1});
                window.open(newWindowUrl, '', '');
            }

            if (typeof(useSapIdLogin) != "undefined" && useSapIdLogin) {
                sapIdLogin.handleOnLoad();
            } else {
                // if taiwan
                let nsConfig = ConfigService.getMarketConfig();
                if (document.URL.indexOf("zh_TW") !=-1 && thisAM.useTaiwanLogin()) {

                    var authentication = UserService.getUser();
                    let checkUrl = nsConfig.taiwan.taiwanPingUrl;
                    let parameters = {};
                    let src = nsConfig.taiwan.taiwanPingUrl+"?jsonp=nuskin.account.AccountManager.taiwanPingReturn&ts="+new Date().getTime();
                    if (authentication) {
                        thisAM.currentData = authentication;
                        // this script will log the user in and out.
                        // it doesnt matter if they are logged in yet or not
                        // todo update the taiwanPingUrl to the one below
                        src = src+"memberId="+thisAM.currentData.id;
                    }

                    let pingStr = "ping-"+(new Date().getTime());
                    $.ajax({
                        type: "GET",
                        url: src,
                        dataType: "jsonp",
                        data: pingStr
                    });
                } else {
                    // everyone else
                    var authentication = UserService.getUser();
                    if(authentication) {
                        thisAM.currentData = authentication;
                        if (typeof(CQ_Analytics) != 'undefined' && CQ_Analytics && CQ_Analytics.ProfileDataMgr && !nsConfig.taiwan.enableGlobalAuth) {
                            try {
                                // in case the user does not have any rank (pin title), some backend data has problem
                                CQ_Analytics.ProfileDataMgr.setProperty('pinLevel',  parseInt(authentication.highestRank));
                            } catch (e) {
                                CQ_Analytics.ProfileDataMgr.setProperty('pinLevel',  0);
                            }
                        }

                        //publish the event to the page.  if the ping shows the session
                        //is invalid the included js file will call the logout function
                        events.publish(events.authentication.VALID, [authentication]);
                        events.publish(events.account.VOLUME_ADDED, [authentication]);
                        if (nsConfig.taiwan.enableGlobalAuth) {
                            thisAM.ping();
                        } else if (!nuskin.account.AccountManager.isEmeaSignup()) {
                            nuskin.account.AccountManager.ping();
                        }
                    } else {
                        // events.publish(events.account.INIT_COMPLETE);
                        events.setValue(events.account.INIT_COMPLETE);
                        if (typeof(CQ_Analytics) != 'undefined' && CQ_Analytics && CQ_Analytics.ProfileDataMgr) {
                            CQ_Analytics.ProfileDataMgr.setProperty('qualifiedCampaigns', ''); // resetting qualified campaigns
                            CQ_Analytics.ProfileDataMgr.setProperty('pinLevel', 0); // resetting pinLevel
                        }
                    }
                }
            }

            let favoritesSku = localStorage.getItem(keys.FAVORITES_SKU);
            if (favoritesSku && thisAM.isLoggedIn()) {
                nuskin.shop.addToFavoritesList(favoritesSku.toString());
                localStorage.removeItem(keys.FAVORITES_SKU);
                if (localStorage[keys.FAVORITES_QUICKVIEW]) {
                    $(document).trigger("show-Favorites-QuickView");
                } else {
                    $('div.addedToCart').each(function() {
                        $(this).fadeIn();
                    });
                }
            }

            if (nuskin.account.AccountManager.isEmeaSignup()) {
                nuskin.account.AccountManager.setupEMEASignup();
            }
        };

        this.setAuthReturnHandler = function(handler){
            authReturnHandler = handler;
        };

        util.Initializer.addOnLoad(onLoad);
    }

    nuskin.account.AccountManager = new AccountManager();
}

export default nuskin.account.AccountManager;
export var account = nuskin.account;
